import { useState } from "react";
import { ButtonGroup, Dropdown, SplitButton } from "react-bootstrap";
import styles from '../../css/styles.module.css'

export function Course(props) {
    const { isShimmer, course, coursestatus, attendedCourse, statusRequest, handleStatusChange, isBuildCreditCount, isBuildNewRank } = props;

    let [selectedcoursestatus, setSelectedcoursestatus] = useState(attendedCourse?.coursestatus)
    const handleSelectStatus = (statusIndex) => {
        const status = coursestatus?.data[statusIndex] ?? ''
        setSelectedcoursestatus(status)
        handleStatusChange(statusIndex);
    }

    return (
        <>
            {isBuildNewRank && (
                <tr>
                    <td className='bg-warning fw-bold'>Semester {course.rank}</td>
                    <td className='bg-warning'> </td>
                    <td className='bg-warning'></td>
                    <td className='bg-warning'></td>
                </tr>
            )}
            <tr>
                <td>{course?.course?.code} {course?.course?.name}</td>
                <td>{course?.course?.credit}</td>
                <td>{course?.course?.preRequisite}</td>
                <td>
                    {
                        isShimmer ?
                            isShimmer :

                            <SplitButton
                                as={ButtonGroup}
                                id={`dropdown-variants-status-course`}
                                variant='primary'
                                className={`${styles.w_200}`}
                                disabled={
                                    selectedcoursestatus?.length === 0
                                    || statusRequest === 'approved'
                                }
                                onSelect={(e) => handleSelectStatus(e - 1)}
                                title={selectedcoursestatus?.name ?? ''}
                            >
                                {(coursestatus?.data ?? []).map((element, index) => {
                                    const offer = course.course.offer
                                    if (index > 5) return
                                    return (
                                        <Dropdown.Item
                                            disabled={(offer === false) && ((element.isActive ?? false) === false)}
                                            className='btn-outline-primary'
                                            key={`course-status-${element.id}`}
                                            eventKey={element?.id ?? '-1'}
                                        >
                                            {element?.name ?? ''}
                                        </Dropdown.Item>
                                    )
                                })}
                            </SplitButton>
                    }
                </td>
            </tr>
            {isBuildCreditCount && (
                <tr>
                    <td></td>
                    {/* <td className='text-black fw-bold'>Total credits: {credits}</td> */}
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            )}
        </>
    );
}